export const SET_PREDICT_LOCATIONS = 'SET_PREDICT_LOCATIONS'
export const CLEAR_PREDICT_LOCATIONS = 'CLEAR_PREDICT_LOCATIONS'
export const SET_CURRENT_INPUT = 'SET_CURRENT_INPUT'
